'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContainerStyled = require('./styles/ContainerStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /** Container will have maximum width and will be centered on screen */
  boxed: _propTypes2.default.bool,
  /** Container will occupy all available space */
  spread: _propTypes2.default.bool
};

var defaultProps = {
  boxed: false,
  spread: false
};

var Container = exports.Container = function Container(props) {
  return _react2.default.createElement(
    _ContainerStyled.ContainerStyled,
    { boxed: props.boxed, spread: props.spread },
    props.children
  );
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
Container.displayName = 'Container';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-grid/dist/Container/Container.js
// module id = 685
// module chunks = 0